import React, { Component } from "react";
import { Button, Grid, Input, TextField, Typography } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import {primaryColor, webFont} from "../../config/theme";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import NativeSelect from '@material-ui/core/NativeSelect';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import { NotificationManager } from "react-notifications";
import Fab from "@material-ui/core/Fab";
import MenuItem from '@material-ui/core/MenuItem';
import {compose, graphql} from "react-apollo";
import {connect} from "react-redux";
import {CREATE_SUPPORT_PROFILE,SUBMIT_FEEDBACK} from "../../graphql/mutations/user";
import {getUser} from "../../redux/user";


class Feedback extends Component {
  constructor(props) {
    super(props);

    this.state = {
      feedbackType: [
        'FEATURE_IDEA',
        'BUG',
        'PRICING',
        'BOOKING',
        'BOOKING_DISPUTE',
        'PAYMENTS',
        'MY_ACCOUNT',
        'REVIEWS',
        'OTHER'
      ],
      selectedType: this.props.booking ? 'BOOKING_DISPUTE' : 'FEATURE_IDEA',
      message: this.props.booking ? `Booking Id: ${this.props.booking}` : ''
    };
  }

    handleChange = event => {
        this.setState({ selectedType: event.target.value });
    };

    handleMessageChange = event => {
    // if(event.target.value.length<=500)
        this.setState({ message: event.target.value });
    };
    handleSubmit = () => {
        let {selectedType,message}=this.state;
        if (selectedType.toLowerCase() === 'my_account') {
            selectedType = 'MYACCOUNT';
        }
        if(selectedType && message){
            const { createSupportProfile,submitFeedback ,userId} = this.props;
            createSupportProfile({
                variables: { userId: userId }
            })
                .then(res => {
                    let payload={ type: selectedType,feedback:message };

                    submitFeedback({
                        variables: payload
                    })
                        .then(res => {
                            this.setState({  selectedType:'',
                                message:''});
                            NotificationManager.info("Your feedback has been submitted.");
                        })
                        .catch(err => {
                            console.log(JSON.parse(JSON.stringify(err)));
                            NotificationManager.error("Details are not saved");
                        });
                })
                .catch(err => {
                    console.log(JSON.parse(JSON.stringify(err)));
                    NotificationManager.error("Details are not saved");
                });
        }else{
            NotificationManager.error("All fields are required");
        }
    };

    componentDidMount() {
      if (this.props.match) {
        if (this.props.match.params) {
          if (this.props.match.params.type && this.props.match.params.booking) {
            this.handleChange({target: { value: 'BOOKING_DISPUTE' }})
            this.handleMessageChange({ target: { value: `Booking Id: ${this.props.match.params.booking}` }});
          } //end-if params.type && params.booking
        } //end-if match.params
      } // end-if match
    }


  render() {
        const {feedbackType, message}=this.state;
        console.log('INCOMING STATE: ', this.state);
        const feedType=feedbackType.map(feedback  => {
           return (
               <MenuItem selected={feedback === feedbackType} className="subject-feedback-option" value={feedback}>{feedback.substr(0,1).toUpperCase()}{feedback.replace('_',' ').substring(1).toLowerCase()}</MenuItem>
           )
        });

        return (
            <div>
                <Grid container>
                    <Grid item xs={12}>
                        <Typography
                            style={{
                                ...styles.setFont,
                                fontSize: 30,
                                fontWeight: 500,
                                marginBottom: 20
                            }}
                        >
                            How can we help?
                        </Typography>
                    </Grid>
                </Grid>

              <Grid container>
              <Grid item xs={12}>
                <Typography
                  style={{
                    ...styles.setFont,
                    fontSize: 15,
                    fontWeight: 500,
                    marginBottom: 20,
                    textTransform: 'uppercase'
                  }}
                >
                  Subject
                </Typography>
              </Grid>

              <Grid
                data-test-id={"feedbacktype"}
                item xs={12}>
                <Select
                  inputProps={{MenuProps: {disableScrollLock: true}}}
                  value={this.state.selectedType}
                  onChange={this.handleChange}
                  defaultValue={this.state.selectedType}
                  input={
                    <OutlinedInput
                      name="age"
                      id="outlined-age-simple"
                      style={{width: 400}}
                    />
                  }
                >
                    {feedType}
                </Select>
              </Grid>
            </Grid>
              <Grid container style={{width: 400}}>
                <Grid item>
                  <Typography
                    style={{
                      ...styles.setFont,
                      fontSize: 15,
                      fontWeight: 500,
                      marginTop: 40,
                      textTransform: 'uppercase'
                    }}
                  >
                    Message
                  </Typography>
                </Grid>

                <Grid item style={{width: '100%'}}>
                  <div
                    style={{
                      opacity: 0.62,
                      borderRadius: 2,
                      borderWidth: 1,
                      borderColor: "#979797"
                    }}
                  >
                    <TextField
                      inputProps={{ 'data-test-id': 'fbmsg' }}
                      id="outlined-with-placeholder"
                      multiline="true"
                      rows="6"
                      placeholder="How do you think we can provide you a better experience?"
                      margin="normal"
                      variant="outlined"
                      value={message}
                      defaultValue={this.state.message}
                      onChange={this.handleMessageChange}
                      style={{width: '100%'}}
                    />
                  </div>
                </Grid>
                <Grid container>
                    <Grid item md={12} style={{ margin: '30px 0', textAlign: 'left'}}>
                        <Fab
                          data-test-id={"submitbtn"}
                          variant={"extended"}
                          disabled={this.props.loading}
                          type="submit"
                          style={styles.submitButton}
                          onClick={this.handleSubmit}
                        >
                            Submit
                        </Fab>
                    </Grid>
                </Grid>
              </Grid>
            </div>
        );
    }
}
const mapSateToProps = state => {
    return {
        userId: state.auth.userId
    };
};
const submitFeedbackWithData = compose(
    graphql(CREATE_SUPPORT_PROFILE, { name: "createSupportProfile" }),
    graphql(SUBMIT_FEEDBACK, { name: "submitFeedback" })
)(Feedback);
const SumbitFeedbackData = withRouter(connect(mapSateToProps)(submitFeedbackWithData));

export default SumbitFeedbackData;
const styles={
    setFont: {
        fontFamily: webFont
    },
    submitButton: {
        borderRadius: 25,
        backgroundColor: primaryColor,
        border: "none",
        minWidth: 204,
        color: "white",
        height: 49,
        fontFamily: webFont,
        textTransform: "none",
        fontSize: 18,
        boxShadow: 'none'
    }
};
